import { render } from "./property-market.vue?vue&type=template&id=5090f8ee"
import script from "./property-market.js?vue&type=script&lang=js"
export * from "./property-market.js?vue&type=script&lang=js"

import "./property-market.vue?vue&type=style&index=0&id=5090f8ee&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__